import type { ReactNode } from 'react';
import { styled } from '@mui/material/styles';

export type ContractTypeBadgeProps = {
  color: string;
  backgroundColor: string;
  children: ReactNode;
};

/**
 * Colored pill labeling a contract volet as SST or PDS. Colors are passed in
 * by the caller (rather than baked in from a single palette) since this badge
 * is shared between a legacy `theme.palette` consumer (`DocumentVoletCard`)
 * and a design-system-V2 `dsV2` consumer (`LegalContractFile`) — see
 * `ds-v2-tokens.ts` for why those two token sets are intentionally distinct.
 */
const ContractTypeBadge = ({ color, backgroundColor, children }: ContractTypeBadgeProps) => (
  <Badge sx={{ color, backgroundColor }}>{children}</Badge>
);

export default ContractTypeBadge;

const Badge = styled('span')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  padding: '3px 8px',
  borderRadius: 6,
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '0.02em',
  lineHeight: 1.3,
  whiteSpace: 'nowrap',
}));
